import session from "../../../../services/session";
import swal from "sweetalert2";
import AdminApi from '../../../../services/api'
import CONFIG_COMPANY from "../../../../services/myConfig";
import Loc from "../../../../services/localization";

const AdminApiService = new AdminApi();
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            packages: [],
            selectedPackage: null,
            additionalTypes: [],
            locations: [],
            selectedLocation: null,
            selectedDiscount: 0,
            enableMakingBills: false,
            discounts: [0, 10, 15, 20,],
            showMemberShipForProgram: CONFIG_COMPANY.SHOW_MEMBERSHIP_FOR_PROGRAMS != null ? CONFIG_COMPANY.SHOW_MEMBERSHIP_FOR_PROGRAMS : false,
            model: {
                expireDate: null,
                paidDate: null,
                paidMoney: 1,
                trainingNumber: 0,
                userId: 0,
                addTrainingsWithCurrentState: false,
                isForCompany: false,
                invoiceLink: '',
                comment: '',
                types: CONFIG_COMPANY.DEFAULT_TRAINING_TYPES,
                additionalService: false,
                forProgram: false,
                selectedLocationForBill: null
            },
            paymentTypes: {
                STANDARD: {
                    id: 1,
                    label: LocService.t('label_standard_payment'),
                    value: false
                },
                ADDITIONAL_SERVICE: {
                    id: 2,
                    label: LocService.t('label_additional_payment'),
                    value: true
                },
            },
            kits: [],
            allKits: [],
            types: [],
            filteredTypes: [],
            showConcreteValueForPayment: false,
            showPaymentInvoiceLink: false,
            addNumberTrainingsWithNewPaymentWithCurrentState: false,

        }
    },
    methods: {
        addPayment: addPayment,
        loadMembership: loadMembership,
        isSelectedType: isSelectedType,
        getChipClass: getChipClass,
        getChipTypeClass: getChipTypeClass,
        isSelected: isSelected,
        onSelectedPackage: onSelectedPackage,
        getAdditionalKits: getAdditionalKits,
        openTrainingTypes: openTrainingTypes,
        getTrainingTypes: getTrainingTypes,
        setSelectedCheckBox: setSelectedCheckBox,
        openAdditionalKit: openAdditionalKit,
        onChangeCheckBox: onChangeCheckBox,
        onChangeCheckBoxKits: onChangeCheckBoxKits,
        setSelectedCheckBoxKits: setSelectedCheckBoxKits,
        generateKits: generateKits,
        selectLocation: selectLocation,
        formatMoney: formatMoney,
        getTotalPriceWithDiscount: getTotalPriceWithDiscount,
        selectDiscount(value) {
            this.selectedDiscount = value;
        },
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        },
        isMainAdmin() {
            let value = localStorage.getItem('IS_MAIN_ADMIN');
            return value == null ? false : value === 'true' || value === true;
        },
    },
    beforeMount() {
        if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_TRAINER') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.model.userId = this.$route.query.id;
        this.getTrainingTypes()
        this.getAdditionalKits()
        if(session.getConfig().showConcreteValueForPayment != null){
            this.showConcreteValueForPayment = session.getConfig().showConcreteValueForPayment;
            if(this.showConcreteValueForPayment){
                this.model.paidMoney = 0;
            }
        }
        if(session.getConfig().additionalServiceTypes != null && session.getConfig().additionalServiceTypes.length > 0){
            this.additionalTypes = session.getConfig().additionalServiceTypes.split(";").filter(e => e.length > 0)
        }
        if(session.getConfig().addNumberTrainingsWithNewPaymentWithCurrentState != null){
            this.addNumberTrainingsWithNewPaymentWithCurrentState = session.getConfig().addNumberTrainingsWithNewPaymentWithCurrentState
            if(CONFIG_COMPANY.ADD_NUMBER_TRAININGS_WITH_NEW_PAYMENT_DEFAULT_VALUE !=  null){
                this.model.addTrainingsWithCurrentState = CONFIG_COMPANY.ADD_NUMBER_TRAININGS_WITH_NEW_PAYMENT_DEFAULT_VALUE
            }else{
                this.model.addTrainingsWithCurrentState = session.getConfig().addNumberTrainingsWithNewPaymentWithCurrentState
            }
        }
        //ovo je zakucano na config na front
        if(CONFIG_COMPANY.ADD_NUMBER_TRAININGS_WITH_NEW_PAYMENT_FORCE_CONFIG != null){
            this.addNumberTrainingsWithNewPaymentWithCurrentState = CONFIG_COMPANY.ADD_NUMBER_TRAININGS_WITH_NEW_PAYMENT_FORCE_CONFIG
        }

        this.enableMakingBills = session.getConfig().enableMakingBills != null ? session.getConfig().enableMakingBills : false;
        if(session.getConfig().customCategories != null && this.enableMakingBills){
            this.locations = session.getConfig().customCategories.split(";").filter(e => e.length > 0);
            let userLocation = session.getUserLocation();
            if(userLocation != null && userLocation.length > 0){
                this.locations = this.locations.filter(l => userLocation.includes(l));
            }
            if(this.selectedLocation == null && this.locations.length > 0){
                this.selectedLocation = this.locations[0];
            }
        }

        if(session.getConfig().showPaymentInvoiceLink != null){
            this.showPaymentInvoiceLink = session.getConfig().showPaymentInvoiceLink;
        }
        this.model.paidDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.loadMembership();
    },
    watch: {
        'model.additionalService': function (newVal) {
            if(newVal){
                this.model.types = [];
                this.filteredTypes = this.types.filter(e => this.additionalTypes.includes(e))
                this.model.types = this.filteredTypes;

            }else{
                this.filteredTypes = this.types;
                this.model.types = CONFIG_COMPANY.DEFAULT_TRAINING_TYPES;
            }
        }
    }
}

function selectLocation(location){
    this.selectedLocation = location;
}

function loadMembership() {
    let _self = this;
    AdminApiService.getMemberships()
        .then((response) => {
            _self.packages = response.data;
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function addPayment() {
    let _self = this;
    if(_self.model.types.length === 0){
        swal(LocService.t("label_error"),LocService.t('label_payment_error_choose_type'), 'error')
        return;
    }
    if(this.selectedDiscount != null){
        if(this.selectedDiscount < 0 || this.selectedDiscount > 100){
            swal(LocService.t("label_error"), LocService.t('label_discount_desc_error'), 'error')
            return;
        }
    }
    _self.model.paidDate =this.model.paidDate + 'T00:00:00.000Z';
    _self.model.expireDate =this.model.expireDate + 'T00:00:00.000Z';
    _self.model.additionalKit = this.generateKits();
    _self.model.types = _self.model.types.filter(e => e.length > 0)
    _self.model.membershipPackageId = _self.selectedPackage != null ? _self.selectedPackage.id : null;
    _self.model.membershipPackageName = _self.selectedPackage != null ? _self.selectedPackage.name : null;
    _self.model.selectedLocationForBill = _self.selectedLocation
    _self.model.discount = _self.selectedDiscount == null ? 0 : _self.selectedDiscount;
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {
    });
    AdminApiService.addPayment(_self.model)
        .then((response) => {
            swal(LocService.t("label_success"), LocService.t('label_payment_success_add'), 'success')
            _self.$router.push('/user-profile?id=' +  _self.model.userId + '&type=payments')
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}
function generateKits(){
    if(this.kits.length === 0) return '';
    var i = 0;
    var kit = '';
    for(i = 0; i < this.kits.length; i++){
        kit = kit + this.kits[i] + ';'
    }
    return kit;
}

function getTrainingTypes() {
    let _self = this;
    AdminApiService.getTrainingTypes()
        .then((response) => {
            _self.types =  Object.keys(response.data);
            _self.filteredTypes = _self.types;
        })
        .catch(error => {
            console.log(error)
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function getAdditionalKits(){
    let _self = this;
    AdminApiService.getAdditionalKit()
        .then((response) => {
            _self.allKits = response.data;
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function onChangeCheckBox(key) {
    let isChecked = document.getElementById(key).checked
    if(isChecked){
        if(this.model.types.indexOf(key) < 0){
            this.model.types.push(key);
        }
    }else{
        const index = this.model.types.indexOf(key);
        if (index > -1) {
            this.model.types.splice(index, 1);
        }
    }
}

function onChangeCheckBoxKits(key) {
    let isChecked = document.getElementById(key).checked
    if(isChecked){
        if(this.kits.indexOf(key) < 0){
            this.kits.push(key);
        }
    }else{
        const index = this.kits.indexOf(key);
        if (index > -1) {
            this.kits.splice(index, 1);
        }
    }
}

function setSelectedCheckBox(key) {
    return this.model.types.indexOf(key) > -1
}

function setSelectedCheckBoxKits(key) {
    return this.kits.indexOf(key) > -1
}

function openAdditionalKit(){
    this.$router.push('additional-kits')
}


function openTrainingTypes(){
    this.$router.push('training-types')
}


function getChipClass(item){
    if(this.selectedPackage == null) return 'chip-unselected';
    if(this.selectedPackage.id === item.id) return 'chip-selected'
    return 'chip-unselected';
}

function getChipTypeClass(item){
    if(this.model.additionalService === item.value) return 'chip-selected';
    return 'chip-unselected';
}

function isSelected(item){
    if(this.selectedPackage == null) return false;
    return this.selectedPackage.id === item.id
}

function isSelectedType(item){
    return this.model.additionalService === item.value;
}

function onSelectedPackage(item){
    this.selectedPackage = item
    this.model.additionalService = item.additionalService != null ? item.additionalService : false;
    this.model.types = item.trainingTypes.split(",")
    this.model.trainingNumber = item.trainingNumber;
    this.paidMoney = item.price;
    this.model.paidMoney = item.price;
    this.model.forProgram = item.forProgram != null ? item.forProgram : false;
    if(item.additionalKit != null && item.additionalKit.length > 0){
        this.kits = item.additionalKit.split(";").filter(i => i.length > 0)
    }
    if(this.model.paidDate != null){
        this.model.expireDate = this.$moment(this.model.paidDate).add(item.durationInDays, 'days').format('YYYY-MM-DD');
    }
    // this.model.types = item.
}

function getTotalPriceWithDiscount(){
    if(this.model.paidMoney == null) return 0;
    if(this.model.paidMoney === 0) return 0;
    let total = this.model.paidMoney;
    if(this.selectedDiscount == null) return total;
    if(this.selectedDiscount === 0) return total;
    const discountAmount = total * (this.selectedDiscount / 100);
    return total - discountAmount;
}

function formatMoney(value) {
    // prilagodi valutu ako želiš (RSD/EUR)
    return new Intl.NumberFormat('sr-RS', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(value);
}


// WEBPACK FOOTER //
// ./src/components/Users/Payment/Add/AddPayment.js